
export default () => '99:99'
